/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountupgradedtobusiness3Inputs */

const en_accountupgradedtobusiness3 = /** @type {(inputs: Accountupgradedtobusiness3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account is now a business account.`)
};

const de_accountupgradedtobusiness3 = /** @type {(inputs: Accountupgradedtobusiness3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Konto ist jetzt ein Business-Konto.`)
};

/**
* | output |
* | --- |
* | "Your account is now a business account." |
*
* @param {Accountupgradedtobusiness3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const accountupgradedtobusiness3 = /** @type {((inputs?: Accountupgradedtobusiness3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountupgradedtobusiness3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accountupgradedtobusiness3(inputs)
	return de_accountupgradedtobusiness3(inputs)
});
export { accountupgradedtobusiness3 as "accountUpgradedToBusiness" }